import { enableProdMode, VERSION } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js/dist/zone';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
} else {
    console.info("DEV mode: Angular " + VERSION.full);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
